import { Component, OnInit, Output, EventEmitter, Inject,ViewChild,TemplateRef, AfterViewInit,  ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { EventService } from '../../core/services/event.service';
import { AuthenticationService } from '../../core/services/auth.service';
import { DOCUMENT } from '@angular/common';
import { MenuService } from 'src/app/core/services/menu.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { MenuEvent } from 'src/app/core/services/menuevent.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modalform',
  templateUrl: './modalform.component.html',
  styleUrls: ['./modalform.component.scss']
})
export class ModalformComponent implements OnInit {
  strMenuCopania: string = "api/servicios/SeleccionarCompania";
  MenuCopania = [];
  ModuloDefault: any
  MostrarFiltroPrincipal : any
  CNT05COD: any;
  M05COD :any;
  CNT05DES: any;
  M05DES :any;
  strWsModulo :string = "api/mantenimientos/MenuModulos";
  MenuModulo = [];
  strWsURLMENU: string = "api/mantenimientos/MenuPrincipal";
  menuItems = [];
  

  constructor(  private dataService: SharedService,
    public languageService: LanguageService,
    private menuEvent: MenuEvent,
    // tslint:disable-next-line: variable-name
    public _cookiesService: CookieService,
    public menuService: MenuService,
    private modalService: NgbModal) { }

    @ViewChild('contenidosedes') contenidosedes:TemplateRef<any>;

  ngOnInit(): void {    
    this.initialize2();
  }

  initialize2(): void {  
  this.abrirModal("");
  }

  abrirModal(index){
    this.dataService.Consultar(this.strMenuCopania).subscribe((datosResp4: any) => {
      this.MenuCopania = datosResp4 
      
      
      this.dataService.Ejecutar(this.strWsModulo).subscribe(
        (datosResp5: any) => {
          this.MenuModulo = datosResp5;
          this.modalService.open(this.contenidosedes, { size: 'xl' });    
        });
    });

   
    
    if(this.CNT05COD == "" || this.CNT05COD == undefined || this.CNT05COD == 'null' || this.M05COD == ""  || this.M05COD == undefined || this.M05COD == 'null'){
      this.obtener_localstorage();
    }
    
  }
  guardar(event){
    var CNT05 = (document.getElementById("compania")) as HTMLSelectElement;
    var opt = CNT05.options[CNT05.selectedIndex];
    if(opt != undefined ){
      this.CNT05COD = opt.value;
      this.CNT05DES = opt.text;
    }

    var e = (document.getElementById("sede")) as HTMLSelectElement;
    var opt1 = e.options[e.selectedIndex];
    if(opt1 != undefined ){
      this.M05COD = opt1.value;
      this.M05DES = opt1.text;
    }
   

    var e = (document.getElementById("filtros")) as HTMLSelectElement;
    var opt2 = e.options[e.selectedIndex];
    if(opt2 != undefined ){
      this.MostrarFiltroPrincipal = opt2.value;
    }

    var w = (document.getElementById("moddefault")) as HTMLSelectElement;
    var opt3 = w.options[w.selectedIndex];    
    if(opt3 != undefined ){
      this.ModuloDefault = opt3.value;    
    }

    if(opt == undefined || opt == undefined){
      Swal.fire({
        title: 'Error',
        text: 'Debe ingresar la Sede y Compa�ia',
        icon: 'error',
      })
    }

    this.grabar_localstorage();
    this.modalService.dismissAll();   

    if(this.ModuloDefault != '' || this.ModuloDefault != undefined){
      let filtro = "";
      let jsonFiltros = JSON.parse("{ \"FILTROS_OPCIONALES\"   : [ { \"S14DES\" : \"" + filtro + "\", \"S02COD\" : \"" + this.ModuloDefault + "\" }]}");
      this.dataService.Ejecutar(this.strWsURLMENU, jsonFiltros).subscribe(
      (datosResp: any) => {
        this.menuItems = datosResp;          
      });
    }
  }
 
  grabar_localstorage(){
    localStorage.setItem("X-AVATAR-CNT05COD",this.CNT05COD);
    localStorage.setItem("X-AVATAR-M05COD",this.M05COD)
    localStorage.setItem("X-AVATAR-CNT05DES",this.CNT05DES);
    localStorage.setItem("X-AVATAR-M05DES",this.M05DES)

    localStorage.setItem("X-AVATAR-MOSTRARFILTRO",this.MostrarFiltroPrincipal)    
    localStorage.setItem("X-AVATAR-MODULODEFAULT",this.ModuloDefault)    
  }

  obtener_localstorage(){
    this.CNT05COD = localStorage.getItem("X-AVATAR-CNT05COD");
    this.CNT05DES = localStorage.getItem("X-AVATAR-CNT05DES");

    this.M05COD = localStorage.getItem("X-AVATAR-M05COD");
    this.M05DES = localStorage.getItem("X-AVATAR-M05DES");

    this.MostrarFiltroPrincipal = localStorage.getItem("X-AVATAR-MOSTRARFILTRO");
    this.ModuloDefault = localStorage.getItem("X-AVATAR-MODULODEFAULT");
  }

}
